<script>
  import { onMount } from "svelte";
  import PlanoCard from "./PlanoCard.svelte";
  import Afiliados from "./Afiliados.svelte";
  import Duvidas from "./Duvidas.svelte";
  import Conexoes from "../../Classes/Conexoes";
  import Constantes from "../../Classes/Constantes";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  let isLoading = false;
  const conexao = new Conexoes();
  let alunos = 10;
  let precoEstaticoBronze = "R$ 2.50";
  let precoEstaticoPrata = "R$ 3.00";
  let precoEstaticoOuro = "R$ 4.00";
  let precoEstaticoDiamante = "R$ 2.80";

  let precoBronze = alunos * 2.5;
  let precoPrata = alunos * 3;
  let precoOuro = alunos * 4;
  let precoDiamante = alunos * 4 * 0.7;
  let resultados = [];
  onMount(() => {
    PegaDados();
  });
  isLoading = true;
  async function PegaDados() {
    resultados = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: Constantes.query_code_consultar_planos_contratacao,
    });

    isLoading = false;
  }
</script>

<LoadingTela {isLoading} />
<!-- Ajuste de espaçamento para não ficar atrás do NAV -->
<br /><br />

<div class="container">
  <div class="chamada">
    Transforme a forma como você gerencia os treinos dos seus alunos com o <strong
      >FitPace</strong
    >. Rápido, fácil e eficiente para professores de educação física e
    treinadores!
  </div>

  <div class="slider-container">
    <h3>Escolha o seu pacote</h3>
    <input
      type="range"
      min="10"
      max="100"
      step="10"
      bind:value={alunos}
      class="slider"
    />
    <p>{alunos} alunos selecionados</p>
  </div>

  <div class="planos">
    {#each resultados as resultado}
      <PlanoCard
        precoEstatico={resultado.valor_plano}
        titulo={resultado.nome_plano}
        pacote={alunos}
        descricao={resultado.descricao}
        icone={resultado.classe_icone}
        destaque={resultado.destaque}
        anual={resultado.anual}
        id_plano={resultado.id}
      />
    {/each}
  </div>

  <div class="afiliados-section">
    <Afiliados />
  </div>

  <Duvidas />
</div>

<style>
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background-image: url("/img/corrida_deserto.jpg");
    background-size: cover;
    background-position: center;
  }

  .planos {
    display: flex;
    gap: 20px;
    justify-content: space-around;
    flex-wrap: wrap; /* Permite que os itens quebrem linha em telas menores */
    margin: 40px 0;
  }

  .chamada {
    text-align: center;
    margin: 40px 0;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }

  .slider-container {
    text-align: center;
    margin: 20px 0;
  }

  .slider {
    width: 50%;
    margin: 20px auto;
  }

  .afiliados-section {
    background-color: #f8f9fa;
    padding: 40px 20px;
    text-align: center;
  }

  .destaque {
    font-size: 18px;
    font-weight: bold;
    color: #007bff;
  }

  /* Media Queries */
  @media (max-width: 768px) {
    .slider {
      width: 80%;
    }

    .planos {
      gap: 10px;
      justify-content: center; /* Centraliza os cards */
    }

    .planos > * {
      flex: 1 1 calc(90% - 20px); /* Ajusta a largura dos cards em telas médias */
    }
  }

  @media (max-width: 480px) {
    .chamada {
      font-size: 20px;
    }

    .planos {
      gap: 10px;
      justify-content: center; /* Centraliza os cards */
    }

    .planos > * {
      flex: 1 1 calc(90% - 10px); /* Ajusta a largura dos cards para ocupar quase toda a largura da tela */
    }

    .slider {
      width: 100%;
    }
  }
</style>
